class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.videoId = this?.dataset?.videoid;
    this.thumbnailWrapper = this?.querySelector('.image-wrapper');
    this.getVideoThumbnail();
    this.thumbnailWrapper?.addEventListener(
      'click',
      this.handleImageClick.bind(this),
    );
    this.getVideoReady();
  }
  async getVideoReady() {
    window._wq = window._wq || [];
    window._wq.push({
      id: this.videoId,
      onReady: function (video) {
        video.play();
      },
    });
  }
  async getVideoThumbnail() {
    if (!this.videoId) return;
    try {
      const res = await fetch(
        `https://fast.wistia.net/oembed?url=http://home.wistia.com/medias/${this.videoId}?embedType=async&videoWidth=900`,
      );
      const result = await res?.json();
      const thumbnail = result?.thumbnail_url;

      if (thumbnail) {
        const imageEl = document?.createElement('img');
        imageEl.src = thumbnail;
        this.thumbnailWrapper.appendChild(imageEl);
      }
    } catch (e) {
      console.log(e);
    }
  }
  handleImageClick() {
    if (!this.videoId) return;
    this.thumbnailWrapper.style.display = 'none';
    const image = this?.parentElement?.querySelector('.image-with-text-img');
    if (image) {
      image.style.display = 'none';
    }

    const wistiaWrapper = document?.createElement('div');
    wistiaWrapper.classList.add('wistia-video');
    const wistiaEmbed = document?.createElement('div');
    wistiaEmbed.classList = `wistia_embed wistia_async_${this.videoId}`;
    wistiaWrapper.appendChild(wistiaEmbed);

    this.appendChild(wistiaWrapper);
  }
}

customElements.define('video-player', VideoPlayer);
